import React, { useState } from 'react';
import { Tabs, Tab, Grid } from '@mui/material';
import { useTeamsProAccess } from '../../hooks/useTeamsProAccess';

export const LayoutTabs = ({ tabType, teamMembers, onTabSwitch }) => {
  const [tabValue, setTabValue] = useState(0);
  const { isTeamsProUser } = useTeamsProAccess();

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    onTabSwitch?.(newValue);
  };

  return (
    <Grid>
      <Grid>
        <Tabs 
          value={tabValue} 
          onChange={handleTabChange}
          indicatorColor="secondary"
          textColor="inherit"
          sx={{
            '& .MuiTab-root': { 
              fontWeight: 'normal',
              fontSize: '1rem',
              textTransform: 'none',
            },
            '& .Mui-selected': {
              fontWeight: 'medium'
            },
            '& .MuiTabs-indicator': {
              height: 3,
              backgroundColor: 'secondary.main'
            }
          }}
        >
          <Tab label={tabType} id="project-tab-0" />
          {teamMembers && teamMembers.length > 0 && isTeamsProUser && (
            <Tab label="Shared with Me" id="project-tab-1" />
          )}
        </Tabs>
      </Grid>
    </Grid>
  );
}